import React, { useState } from 'react';
import SEOMetricCard from './SEOMetricCard/SEOMetricCard';
import SemanticResultSection from './SemanticResultSection';
import TagsSection from './TagSection/TagsSection';
import KeywordStuffingSection from './KeywordStuffingSection/KeywordStuffingSection';
import InternalLinkingSection from './InternalLinkingSection/InternalLinkingSection';
import ScoreDisplay from '../ScoreProgressBar/ScoreDisplay';
import { useTranslation } from 'react-i18next';

const SeoScoreContent = ({
  scoreData,
  isEditing,
  websites, // List of internal links provided
  actualHtmlContent,
  setIsEditing,
  handleInputChange,
  checkIfAllLinesGreen, // Function to verify if all links are properly formatted
  userRole,
  onUpdate,
  isKeywordBoxReadOnly,
  combinedKeywords,
  handleKeywordChange,
  orderContentType,
  autoKeywordsGenerationLoading,
  keyword,
  url,
  orderWebsite,
  language,
  country,
  gapAnalysisEnabled,
  onGapEditingChange,
}) => {
  const data = scoreData;
  const { t } = useTranslation();
  const [openSection, setOpenSection] = useState('semantic');
  const metrics = data?.metrics;
  if (
    !data ||
    !metrics ||
    !metrics.semanticResult ||
    !metrics.tags ||
    !metrics.keywordStuffing ||
    !metrics.internalLinking
  ) {
    return null;
  }

  return (
    <>
      <ScoreDisplay score={data.seoScore} />
      <div className="metric-cards-container">
        {/* Semantic Result Card */}
        <SEOMetricCard
          title={t('Résultat sémantique')}
          score={metrics.semanticResult.score ?? 0}
          initialExpanded={true}
          showDivider={false}
          expanded={openSection === 'semantic'}
          onToggle={() => setOpenSection((prev) => (prev === 'semantic' ? '' : 'semantic'))}
          infoTooltip="scoreTooltip.semanticResult"
        >
          <SemanticResultSection
            data={metrics.semanticResult.data}
            details={metrics.semanticResult}
            onUpdate={onUpdate}
            isReadOnly={isKeywordBoxReadOnly}
            combinedKeywords={combinedKeywords}
            handleKeywordChange={handleKeywordChange}
            orderContentType={orderContentType}
            autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
            keyword={keyword}
            url={url}
            orderWebsite={orderWebsite}
            language={language}
            country={country}
            contentScore={scoreData}
            gapAnalysisEnabled={gapAnalysisEnabled}
            onGapEditingChange={onGapEditingChange}
          />
        </SEOMetricCard>
        {/* Tags Card */}
        <SEOMetricCard
          title={t('Balises')}
          score={metrics.tags.score ?? 0}
          expanded={openSection === 'tags'}
          onToggle={() => setOpenSection((prev) => (prev === 'tags' ? '' : 'tags'))}
          infoTooltip="scoreTooltip.tags"
        >
          <TagsSection data={metrics.tags.data} />
        </SEOMetricCard>

        {/* Keyword Stuffing Card */}
        <SEOMetricCard
          title={t(metrics.keywordStuffing.title || 'Keyword stuffing')}
          score={metrics.keywordStuffing.score ?? 0}
          expanded={openSection === 'stuffing'}
          onToggle={() => setOpenSection((prev) => (prev === 'stuffing' ? '' : 'stuffing'))}
          infoTooltip="scoreTooltip.keywordStuffing"
        >
          <KeywordStuffingSection data={metrics.keywordStuffing.data} />
        </SEOMetricCard>

        {/* Internal Linking Card */}
        <SEOMetricCard
          title={t('Maillage interne')}
          score={metrics.internalLinking.score ?? 0}
          expanded={openSection === 'internal'}
          onToggle={() => setOpenSection((prev) => (prev === 'internal' ? '' : 'internal'))}
          infoTooltip="scoreTooltip.internalLinking"
        >
          <InternalLinkingSection
            data={metrics.internalLinking.data}
            details={metrics.internalLinking}
            scoreData={scoreData}
            isEditing={isEditing}
            websites={websites}
            actualHtmlContent={actualHtmlContent}
            setIsEditing={setIsEditing}
            handleInputChange={handleInputChange}
            checkIfAllLinesGreen={checkIfAllLinesGreen}
            userRole={userRole}
            t={t}
          />
        </SEOMetricCard>
      </div>
    </>
  );
};

export default SeoScoreContent;
